module.exports = __webpack_public_path__ + "img/pr-7.9139e929.png";